export default __webpack_public_path__ + "static/media/thumbnail.ccb81722.png";